var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white--text",attrs:{"width":_vm.$vuetify.breakpoint.xs  ? '90%' : '',"color":_vm.insert ? 'blue' : 'green'},on:{"click":function($event){return _vm.btnAdd();}}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.insert ? "mdi-undo-variant" : "mdi-plus")+" ")]),_vm._v(" "+_vm._s(_vm.insert ? "voltar" : _vm.sub)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }